import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import { SUPPORTED } from "@/i18n";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function LanguageSelector({ compact = false }) {
  const { i18n, t } = useTranslation();
  const current = SUPPORTED.find((l) => l.code === (i18n.language || "en").split("-")[0]) || SUPPORTED[0];

  const change = (code) => {
    i18n.changeLanguage(code);
    try { localStorage.setItem("dvnlc_lang", code); } catch (_) { /* ignore */ }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          data-testid="language-selector"
          aria-label={t("nav.language")}
          className="inline-flex items-center gap-1.5 rounded-md border border-amber-500/30 hover:border-amber-400/60 bg-[#0F1C3F]/60 hover:bg-[#0F1C3F] text-amber-300 text-xs font-mono uppercase tracking-widest px-2.5 py-1.5 transition-colors"
        >
          <Globe className="w-3.5 h-3.5" />
          <span>{current.code.toUpperCase()}</span>
          {!compact && <span className="hidden lg:inline text-slate-400 normal-case tracking-normal">· {current.native}</span>}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="max-h-96 overflow-y-auto bg-[#0A1128] border border-amber-500/25 text-slate-100"
        data-testid="language-selector-menu"
      >
        {SUPPORTED.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => change(l.code)}
            data-testid={`lang-${l.code}`}
            className={`cursor-pointer flex items-center justify-between gap-6 focus:bg-amber-500/10 focus:text-amber-300 ${
              l.code === current.code ? "text-amber-300" : ""
            }`}
          >
            <span>{l.native}</span>
            <span className="text-xs font-mono text-slate-500">{l.code.toUpperCase()}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
